import { render, staticRenderFns } from "./SignalTokenVolumeChange.vue?vue&type=template&id=07af5761&scoped=true&"
import script from "./SignalTokenVolumeChange.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenVolumeChange.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af5761",
  null
  
)

export default component.exports